module.exports = __webpack_public_path__ + "static/tatianawork4-3201fd15f13fa504434a620ae6a911df.jpeg";